function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { HttpClient } from 'api/http-client';
import { TeamsAPI } from 'api/teams';
class RoleClient extends HttpClient {
    create(payload) {
        return this.post('/roles', payload);
    }
    update(roleId, payload) {
        return this.put(`/roles/${roleId}`, payload);
    }
    deleteRole(roleId) {
        return this.delete(`/roles/${roleId}`);
    }
    async createWithDefaultPlaceholder(payload) {
        const role = await this.post('/roles', payload);
        await TeamsAPI.createTeam({
            teamName: role.roleName,
            roleId: role.roleId
        });
        return role;
    }
    findAll() {
        return this.get('/roles');
    }
    findAllWithToken(token) {
        return this.get(`/roles?token=${token}`);
    }
    constructor(...args){
        super(...args), _define_property(this, "makeRolesAvailableForPartner", (roleIds)=>this.put('/roles/bulk', roleIds.map((id)=>({
                    roleId: id
                }))));
    }
}
export const RolesApi = new RoleClient();
